import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchGoalData } from "../../action/goalsAction";
import BlankImg from "../../assets/images/blank.jpg";
import { ImageWithFallback } from "../../helper/helper";
import Pagination from "../../component/Pagination";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net";
import "datatables.net-responsive";
import "datatables.net-buttons";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Modal,
  Link,
  Backdrop,
  TableSortLabel,
  CircularProgress,
  Tooltip,
  TextField,
  MenuItem,
} from "@mui/material";
import DeleteIcon from "../../assets/images2/deleteIcon.svg";
import SearchIcon from "@mui/icons-material/Search";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import CheckBox from "../../component/CheckBox";
import LisitingSkeleton from "../common/LisitingSkeleton";
import ViewGoalComments from "../../component/Modals/ViewGoalComments";
import EditIcon from "@mui/icons-material/Edit";
import EditGoal from "../../component/Modals/EditGoal";
import LoadingButton from "@mui/lab/LoadingButton";
import CommentIcon from "@mui/icons-material/Comment";
import moment from "moment";
import DownloadIcon from "@mui/icons-material/Download";
import VideoCell from "../../component/admin/globalVideoCellComponent/Index";
import {
  getGoalStatusColor,
  getGoalStatusLabel,
  GOAL_STATUS_FILTER_OPTIONS,
} from "../../utils/goalStatus";

const goalsColumn = [
  { id: "goal_select", label: "", minWidth: 0, cls: "goal_select " },
  { id: "goal_Videos", label: "VIDEOS", minWidth: 105, cls: "goal_videos" },
  { id: "goal_title", label: "TITLE", minWidth: 0, cls: "goal_title" },
  { id: "goal_region", label: "REGION", minWidth: 0, cls: "goal_region" },
  {
    id: "goal_posted_By",
    label: "POSTED BY",
    minWidth: 0,
    cls: "goal_postedby",
  },
  {
    id: "goal_category",
    label: "CATEGORY",
    minWidth: 0,
    cls: "goal_category",
  },
  // { id: 'goal_from', label: 'FROM', minWidth: 0, cls: 'goal_from' },
  { id: "goal_club", label: "CLUB", minWidth: 0, cls: "goal_club" },
  { id: "goal_scorer", label: "SCORER", minWidth: 0, cls: "goal_scorer" },
  {
    id: "rikognition_status",
    label: "STATUS",
    minWidth: 0,
    cls: "goal_status",
  },
  { id: "createdAt", label: "POSTED AT", minWidth: 0, cls: "goal_from" },
  { id: "goal_action", label: "ACTIONS", minWidth: 0, cls: "goal_actions" },
];

const columnsToSort = [
  "goal_title",
  "goal_region",
  "goal_club",
  "rikognition_status",
];

export default function Goals() {
  const goalData = useSelector((state) => state.goals);
  const token = useSelector((state) => state.auth.token);
  const [goals, setGoals] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const [selectall, setSelectAll] = useState(false);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const deleteSelected = useRef(null);
  const [openLeague, setOpenLeague] = useState(false);
  const multipleSelect = useRef(new Map());
  const [openMulitDelete, setOpenMulitDelete] = useState(false);
  const [openComments, setOpenComments] = useState(false);
  const [openEditGoal, setOpenEditGoal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [sortColumn, setSortColumn] = useState(null);

  const [selectedGoal, setSelectedGoal] = useState(null);
  const [sortOrder, setSortOrder] = useState("ASC");

  const [approvingId, setApprovingId] = useState(null);

  const hasGoalRows = Array.isArray(goals) && goals.length > 0;
  const showSkeleton =
    goalData?.loading && !hasGoalRows && goals !== "NO GOALS!";

  const loadGoals = (page = currentPage) => {
    dispatch(
      fetchGoalData(token, search, page, sortColumn, sortOrder, statusFilter),
    );
  };

  useEffect(() => {
    if (!goalData?.data) return;

    if (goalData.data.success) {
      if (goalData.data?.data?.rows?.length > 0) {
        setGoals(goalData.data.data.rows);
        setCurrentPage(goalData.data.data.currentPage);
        setTotalPages(Math.ceil(goalData.data.data.count / 10));
      } else {
        setGoals("NO GOALS!");
      }
    } else if (!goalData.loading) {
      setGoals("NO GOALS!");
    }
  }, [goalData]);

  useEffect(() => {
    dispatch(
      fetchGoalData(token, search, 1, sortColumn, sortOrder, statusFilter),
    );
  }, [dispatch, token, sortColumn, sortOrder, statusFilter]);

  const handleSort = (column) => {
    const isAsc = sortColumn == column && sortOrder == "ASC";
    setSortOrder(isAsc ? "DESC" : "ASC");
    setSortColumn(column);
  };

  const handleChangePage = (event, newPage) => {
    dispatch(
      fetchGoalData(token, search, newPage, sortColumn, sortOrder, statusFilter),
    );
  };

  function handleSearchClick() {
    dispatch(
      fetchGoalData(token, search, 1, sortColumn, sortOrder, statusFilter),
    );
  }

  function handleDeleteClose() {
    setOpenDelete(false);
  }

  async function handleDelete() {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/deleteGoal/${deleteSelected.current.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.success) {
        loadGoals();
        toast.success("video deleted successfully");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      setOpenDelete(false);
    }
  }

  const handleApprove = async (id) => {
    setApprovingId(id);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/approve-goal-video/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.success) {
        loadGoals();
        toast.success("Goal video approved successfully");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      setApprovingId(null);
    }
  };

  async function handleMultipleDelete() {
    try {
      const ids = Array.from(multipleSelect.current.entries()).map(
        (ele) => ele[0],
      );
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/deleteMultipleGoals`,
        {
          ids,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.success) {
        loadGoals();
        toast.success("Selected videos deleted successfully");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      multipleSelect.current.clear();
      setOpenMulitDelete(false);
    }
  }

  async function handleGoalUpdate(values) {
    try {
      const formData = new FormData();
      formData.append("category", values.category);
      formData.append("club", values.club);
      if (values.club_img instanceof File) {
        formData.append("club_img", values.club_img);
      }
      formData.append("from_uk", values.from_uk);
      formData.append("goal_id", values.goal_id);
      formData.append("postedBy", values.postedBy);
      formData.append("region", values.region);
      formData.append("sub_category", values.sub_category);
      formData.append("title", values.title);
      formData.append("goal_scorer", values.goal_scorer);
      if (values.rikognition_status) {
        formData.append("rikognition_status", values.rikognition_status);
      }
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/updateGoal`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.success) {
        toast.success(response.data.message);
        //   toast.success(test);
        // navigate("/admin/dashboard/banners");
        loadGoals();
        setOpenEditGoal(false);
      } else {
        toast.error(response.data.message);
      }
    } catch (e) {
      toast.error("error !!");
    } finally {
      setLoading(false);
    }
  }

  return (
    <React.Fragment>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress sx={{ color: "#ef364e" }} />
      </Backdrop>
      <ToastContainer />
      <Box className="page_title">
        <Typography variant="h1" component="h1">
          Goals
        </Typography>
      </Box>
      <Box className="page_inner">
        <Box
          className="search_box_wrapper"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            px: { xs: 1, md: 2 },
            width: "100%",
          }}
        >
          <Box className="search_box" sx={{ width: "50%", flexShrink: 0 }}>
            <Box className="input-wrapper">
              <SearchIcon className="searchIcon" onClick={handleSearchClick} />
              <input
                placeholder="Search by title, club name, goal scorer or posted by"
                type="text"
                value={search}
                onChange={(e) => {
                  const nextSearch = e.target.value;
                  setSearch(nextSearch);
                  if (nextSearch.trim() === "") {
                    dispatch(
                      fetchGoalData(
                        token,
                        "",
                        1,
                        sortColumn,
                        sortOrder,
                        statusFilter,
                      ),
                    );
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchClick();
                  }
                }}
              />
              <Button
                className="delete-search-btn"
                onClick={() => {
                  if (
                    multipleSelect.current &&
                    multipleSelect.current.size > 0
                  ) {
                    setOpenMulitDelete(true);
                  } else {
                    toast.error("Please select at least one video");
                  }
                }}
              >
                <DeleteOutlineIcon className="delete-icon" />
              </Button>
            </Box>
          </Box>
          <Box sx={{ flex: "1 1 auto", minWidth: 16 }} />
          <TextField
            select
            size="small"
            label="Status"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{
              width: 180,
              flexShrink: 0,
              mr: { xs: 0, md: 2 },
              bgcolor: "#fff",
            }}
          >
            {GOAL_STATUS_FILTER_OPTIONS.map((option) => (
              <MenuItem key={option.value || "all"} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box className="page_table">
          <TableContainer
            component={Paper}
            className="customer_form goal_table"
            sx={{ overflowX: "auto", scrollbarGutter: "stable" }}
          >
            <Table
              aria-label="leads table"
              id="leadsTable"
              style={{ width: "100%", minWidth: "960px" }}
            >
              <TableHead className="table_Head">
                <TableRow key="goal_tb_head">
                  {goalsColumn.map((column) =>
                    column.id != "goal_select" ? (
                      <TableCell key={column.id} className={column.cls}>
                        {columnsToSort.includes(column.id) ? (
                          <TableSortLabel
                            active={sortColumn === column.id}
                            onClick={() => handleSort(column.id)}
                            direction={sortOrder.toLowerCase()}
                          >
                            {column.label}
                          </TableSortLabel>
                        ) : (
                          column.label
                        )}
                      </TableCell>
                    ) : (
                      <TableCell key={column.id}>
                        <Box className={column.cls + "checkbox-td"}>
                          <input
                            type="checkbox"
                            className="siteCheckBox"
                            checked={selectall}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                multipleSelect.current.clear();
                              }
                              setSelectAll(e.target.checked);
                            }}
                          />
                        </Box>
                      </TableCell>
                    ),
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {hasGoalRows ? (
                  goals.map((value, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Box className="checkbox-td">
                          <CheckBox
                            multipleSelect={multipleSelect}
                            selectall={selectall}
                            data={value}
                            key={value.id}
                          />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <VideoCell
                          link={value?.video_link}
                          thumbnail={value?.thumbnail}
                        />
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper td-title">
                          <Typography
                            variant="h4"
                            component="h4"
                            className="cus_title"
                          >
                            {value.title}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value.region}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value?.goalUserDetails?.firstName +
                              " " +
                              value?.goalUserDetails?.lastName}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper-goalCat">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text "
                          >
                            {`${value?.goalCategory?.name}`}
                          </Typography>

                          {value?.goalSubCategory?.name && (
                            <Typography
                              variant="p"
                              component="p"
                              className="table-text sub-cat"
                            >
                              {`${value?.goalSubCategory?.name}`}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value.club}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value.goal_scorer}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            component="span"
                            sx={{
                              display: "inline-block",
                              px: 1.25,
                              py: 0.35,
                              borderRadius: "999px",
                              fontSize: 12,
                              fontWeight: 600,
                              lineHeight: 1.4,
                              ...getGoalStatusColor(value.rikognition_status),
                            }}
                          >
                            {getGoalStatusLabel(value.rikognition_status)}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {moment(value.createdAt).format(
                              "MMMM Do, YYYY HH:mm",
                            )}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="table-actions">
                          <Box className="action-wrapper">
                            <Button
                              variant="text"
                              className=""
                              sx={{ minWidth: "40px", p: 0 }}
                              onClick={() => {
                                deleteSelected.current = value;
                                setOpenDelete(true);
                              }}
                              title="Delete Goal"
                            >
                              <img src={DeleteIcon} alt="" />
                            </Button>

                            <Button
                              variant="outlined"
                              className="visible_user"
                              onClick={() => {
                                setSelectedGoal(value);
                                setOpenEditGoal(true);
                              }}
                              title="Edit Goal"
                            >
                              <EditIcon className="visible_icon" />
                            </Button>
                            <Button
                              variant="outlined"
                              className="visible_user"
                              onClick={() => {
                                deleteSelected.current = value;
                                setOpenComments(true);
                              }}
                              title="View Comments"
                            >
                              <CommentIcon className="visible_icon" />
                            </Button>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : showSkeleton ? (
                  Array.from({ length: 10 }).map((_, i) => (
                    <LisitingSkeleton key={i} />
                  ))
                ) : (
                  <TableRow component="tr">
                    <TableCell colSpan={11} style={{ textAlign: "center" }}>
                      {goals === "NO GOALS!" ? goals : "No goals found"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ minHeight: 56, display: "flex", alignItems: "center" }}>
            {totalPages > 1 && (
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                handleChangePage={handleChangePage}
              />
            )}
          </Box>
        </Box>
      </Box>
      {/* delete goal video modal  */}
      <Modal
        open={openDelete}
        onClose={handleDeleteClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure . You want to delete this video.
          </Typography>
          <Box className="buttons-div">
            <Button variant="outlined" onClick={() => setOpenDelete(false)}>
              cancel
            </Button>
            <Button variant="outlined" onClick={handleDelete}>
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* model to add goal to leagues */}
      <Modal
        open={openLeague}
        onClose={() => setOpenLeague(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Add Goal to Leagues
          </Typography>
          <Box className="leagues-wrapper">
            <Box className="league">
              <Typography component="p">Elite</Typography>
            </Box>
          </Box>
          <Box className="buttons-div">
            <Button variant="outlined" onClick={() => setOpenLeague(false)}>
              cancel
            </Button>
            <Button variant="outlined" onClick={() => setOpenDelete(false)}>
              Save
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* delete multiple video delete modal  */}
      <Modal
        open={openMulitDelete}
        onClose={() => setOpenMulitDelete(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure . You want to delete the selected videos.
          </Typography>
          <Box className="buttons-div">
            <Button
              variant="outlined"
              onClick={() => setOpenMulitDelete(false)}
            >
              cancel
            </Button>
            <Button variant="outlined" onClick={handleMultipleDelete}>
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* modal for view comments  */}
      <ViewGoalComments
        setOpen={setOpenComments}
        open={openComments}
        selectedGoal={deleteSelected}
      />

      <EditGoal
        setOpen={setOpenEditGoal}
        open={openEditGoal}
        selectedGoal={selectedGoal}
        handleGoalUpdate={handleGoalUpdate}
      />
    </React.Fragment>
  );
}
